<template>
    <div class="mainBox">
        <div class="main-header">
			<el-row :gutter="10">
				<el-col :span="6">
					<el-button type="primary" icon='el-icon-plus' size="medium" @click='handleInsert'>新增用户</el-button>
					<el-button icon='el-icon-refresh' size="medium" @click='init'>刷新</el-button>
				</el-col>
				<el-col :span="18">
					<el-form ref="search_form" :model="searchForm" class='search_form'>
						<el-row :gutter="10">
							<el-col :span="5" :offset="6">
                                <el-form-item prop="username">
                                    <el-input v-model="searchForm.username" size="medium" placeholder="请输入账号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item prop="realname">
                                    <el-input v-model="searchForm.realname" size="medium" placeholder="请输入姓名" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item prop="status">
                                    <el-select v-model="searchForm.status" size="medium" placeholder="请选择状态" clearable>
                                        <el-option label="开启" value="active"></el-option>
                                        <el-option label="关闭" value="unactive"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="primary" class="searchBtn" size="medium" icon='el-icon-search' @click='init'>查询</el-button>
                            </el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>
		</div>
        <div class="main-content">
            <el-table :data="mainLists" border>
                <el-table-column
                    type="index"
                    :index="1"
                    label="序号"
                    width="80px"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="username"
                    label="账号"
                    min-width="100px">
                </el-table-column>
                <el-table-column
                    prop="realname"
                    label="姓名"
                    min-width="100px">
                </el-table-column>
                <el-table-column
                    prop="role_name"
                    label="用户角色"
                    min-width="100px">
                    <template slot-scope="scope">
                        <p>{{scope.row.role && scope.row.role.name}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    min-width="90px">
                    <template slot-scope="scope">
                        <p>{{scope.row.status == 'active' ? '开启' : '关闭'}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="created_at"
                    label="创建时间"
                    align="center"
                    min-width="140px">
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="240"
                    align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="success"
                            size="mini"
                            icon="el-icon-edit"
                            @click="handleUpdate(scope.row)">
                            修改密码
                        </el-button>
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row,scope.$index)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination-footer" v-show="pagination.totalNum > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pagination.page"
                :page-size="pagination.pageSize"
                :total="pagination.totalNum"
                @current-change="pageChangeHandle">
            </el-pagination>
        </div>
        <!--新增或编辑用户-->
        <el-dialog title="用户管理" :visible.sync="showUserDialogVisible" @close="handleReset" :close-on-click-modal="false">
            <userEdit ref="userEdit" :userForm="userForm"></userEdit>
            <template slot="footer">
                <el-button size="medium" @click="handleReset">取消</el-button>
                <el-button size="medium" type="primary" @click="handleSave">确定</el-button>
            </template>
        </el-dialog>
        <!--修改密码-->
        <el-dialog title="修改密码" :visible.sync="showPdDialogVisible" @close="handleReset2" :close-on-click-modal="false">
            <el-form ref="pdForm" :model="pdForm" :rules='pdFormRules' label-width="80px" size="medium" @submit.native.prevent>
                <el-form-item prop='password' label='新密码'>
                    <el-input type='password' v-model="pdForm.password" placeholder='请输入新密码' @keyup.13.native='handleSave2'></el-input>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button size="medium" @click="handleReset2">取消</el-button>
                <el-button size="medium" type="primary" @click="handleSave2">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {userList,userCreate,userUpdate,userDelete,userUpdate_pwd} from '@/utils/getData';
    const userEdit = ()=>import('@/components/content/userEdit');

    export default {
        name: "list",
        components:{
            userEdit
        },
        data(){
            return{
                searchForm:{
                    username:"",//用户名
                    realname:"",//姓名
                    status:"",//状态
                },
                mainLists:[],//列表
                pagination: {
                    page: 1, //当前页数
                    pageSize: 20, //每页显示的条数
                    totalNum: 100 //总条数
                },
                showUserDialogVisible:false,
                userForm:{},//修改用户信息表单
                showPdDialogVisible:false,
                pdForm:{},//修改密码表单
                pdFormRules:{
                    password:[
                        {required:true,message:"请输入新密码"}
                    ]
                },
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(type){
                if(type != "page"){
                    this.pagination.page = 1;
                }
                let formData = this.searchForm;
                formData.page = this.pagination.page;
                const res = await userList(formData);
                if (res.code == 0) {
                    this.pagination.totalNum = res.data.count;
                    this.mainLists = res.data.rows;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
            },
            pageChangeHandle(val){
                this.pagination.page = val;
                this.init("page");
            },
            handleInsert(){//新增
                this.userForm = {status:"active"};
                this.showUserDialogVisible = true;
            },
            handleEdit(currentRow){//编辑
                this.userForm = JSON.parse(JSON.stringify(currentRow));
                this.showUserDialogVisible = true;
            },
            handleSave(){//保存
                const userForm = this.$refs["userEdit"].$refs["userForm"];
                userForm.validate(async valid=>{
                    if(valid){
                        let res = {},formData = userForm.model;
                        if(formData.id){//编辑
                            res = await userUpdate(formData);
                        }else{//新增
                            res = await userCreate(formData);
                        }
                        if (res.code == 0) {
                            if(formData.id){//编辑
                                const index = this.mainLists.findIndex(item=>{
                                    return item.id == formData.id;
                                });
                                if(index != -1){
                                    this.$set(this.mainLists,index,res.data);
                                }
                            }else{//新增
                                this.mainLists.push(res.data);
                            }
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'success'
                            });
                            this.showUserDialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            handleDelete(currentRow,index){//删除
                this.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await userDelete({id:currentRow.id});
                    if (res.code == 0) {
                        this.mainLists.splice(index,1);
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                }).catch((e) => {
                    if(e == 'cancel'){
                        return false;
                    }
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                });
            },
            handleReset(){//重置表单
                this.$refs["userEdit"].$refs["userForm"].resetFields();
                this.showUserDialogVisible = false;
            },
            handleUpdate(currentRow){//修改密码
                this.pdForm = {
                    id:currentRow.id
                };
                this.showPdDialogVisible = true;
            },
            handleSave2(){//保存密码
                const pdForm = this.$refs["pdForm"];
                pdForm.validate(async valid=>{
                    if(valid){
                        let formData = pdForm.model;
                        const res = await userUpdate_pwd(formData);
                        if (res.code == 0) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'success'
                            });
                            this.showPdDialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            handleReset2(){//重置密码表单
                this.$refs["pdForm"].resetFields();
                this.showPdDialogVisible = false;
            },
        }
    }
</script>

<style scoped>
</style>